import React, { useState, useEffect } from "react";
import ShortCuts from "../../Shortcut_Links/ShortCuts";
import { Button, Form, ButtonGroup, Card } from "react-bootstrap";
import { Tabs, Tab } from "react-bootstrap";
import DTHSidebar from "./DTHSidebar";
import { basicAuth } from "../../config";
import { Redirect, useLocation } from "react-router";
import { GlobalContext } from "../../Context/GlobalState";
import { BASE_URL_PAYNOW } from "../../utils/Constants";
import { COLOR_BACKGROUND_BODY } from "../../utils/Themer";

const DthRecharge = () => {
  const [rechargeType, setRechargeType] = useState("Prepaid");
  const [operators, setOperators] = useState([]);
  const { username, password } = basicAuth;
  const location = useLocation();
  const getAllOperators = async () => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      "Basic " + Buffer.from(username + ":" + password).toString("base64")
    );
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Cookie",
      ".AspNetCore.Identity.Application=CfDJ8PA2Dduz6XVGpbQn-N2Kqq7gIRLnlJeQuPd1-kqi9l0gMEItq8TSyy8IuLGimVbCwS9HzUegsBQVaGIoCjfN0-sCdGezLT5o8pamiAxaHfv1oHLl-2CiLj-bVUF5W6FJ1h7--SbWzdlqLigGGWRotDUJgDmkciZlqAKouhdoRMqyS_3TLXhjn7wqev2tQYqD-xF4v22q4AEO4jbsgFszJvnUq5RQ96tBomES4Weh7s0zB5zXmBWxvGtxBeNcUlnJBasYJUISZ6KJAn9ZHEbcTjF9voFa3b0CjhL7QfPC5h7BU3vNyQxVSWKdXwQw62ZEmuPtR8XAXLuEl5rp9C3Sh0beZJdkTlq5MHkcHH9dbmkmV6jjuRn-EVGbHCFejWVq8qE_1zNrxjXOer8JL0rIXIQMGQzToHXmITeAkdyzHEA7wJd1J6APfROijq_tK1TEUEjtEz-0r4Jcql1pgkknXxD5VUljDT-06eQP5Qs7-p49KUjssMMqyj89wfVRw09PHvYf3Pmz--y_LfF_tuzLlG67gofMbgXM8YJJ6Jf69hSooqvX9CrfXDWcJrKagFqNbqKvKqCax42hoTMAIfaLLgNIWJfLyPitp43D3NFenb-1OvIn3DnJxqPmUxGTXTKeveNFtGyLacNu3bNtCV6qx81NJtNBJe8kwDFpo-PPTS9W"
    );

    var raw = JSON.stringify({
      userName: "string",
      categoryId: 3,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const res = await fetch(
        `${BASE_URL_PAYNOW}/api/Operator/GetAllOperators`,
        requestOptions
      );
      const raw = await res.text();
      const data = JSON.parse(raw);
      console.log(data);
      if (data.data) {
        setOperators(data.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getAllOperators();
  }, []);

  return (
    <GlobalContext.Consumer>
      {(context) =>
        context.user == null || context.user.UserType !== "2" ? (
          <Redirect to="/" />
        ) : (
          <>
            <div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch">
              <DTHSidebar details={{ operators }} />
            </div>
            <div style={{backgroundColor:COLOR_BACKGROUND_BODY}}>
              <div className="row" style={{ padding: "0px" }}>
                <ShortCuts path={location.pathname} />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  margin: "10px 10px 0px 10px",
                }}
              >
                <Button
                  variant="success"
                  className="rounded-0"
                  onClick={() => {
                    document
                      .querySelector(".content-wrapper")
                      .classList.toggle("sidebar-icon-only");
                  }}
                >
                  {"Make DTH Recharge"}
                </Button>
              </div>
              <div style={{ display: "flex" }}>
                <Card style={{ flex: "1", margin: "10px", padding: "10px" }}>
                  <strong>{"Latest Bill Payments Details"}</strong>
                </Card>
              </div>
            </div>
          </>
        )
      }
    </GlobalContext.Consumer>
  );
};

export default DthRecharge;
